import { ReactNode } from 'react';
import styles from './ParticipationInfo.module.css';
import { cx } from '@libs/classnames';

type Props = {
  children: ReactNode;
  icon: ReactNode;
  className?: string;
};

export function ParticipationInfo({ children, icon, className }: Props) {
  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.content}>{children}</div>
      <div className={styles.icon}>{icon}</div>
    </div>
  );
}
